import { render, staticRenderFns } from "./MatchDetailsShort.vue?vue&type=template&id=156afc87"
import script from "./MatchDetailsShort.vue?vue&type=script&lang=js"
export * from "./MatchDetailsShort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports